
import _ from 'lodash'

import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'

export const GET_ENTRIES = 'crud-table/GET_ENTRIES'
export const GET_ENTRIES_SUCCESS = 'crud-table/GET_ENTRIES_SUCCESS'

export const SHOW_NEW_ENTRY_FORM = 'crud-table/SHOW_NEW_ENTRY_FORM'
export const HIDE_NEW_ENTRY_FORM = 'crud-table/HIDE_NEW_ENTRY_FORM'

export const UPDATE_ENTRY = 'crud-table/UPDATE_ENTRY'
export const UPDATE_ENTRY_SUCCESS = 'crud-table/UPDATE_ENTRY_SUCCESS'

export const CREATE_ENTRY = 'crud-table/CREATE_ENTRY'
export const CREATE_ENTRY_SUCCESS = 'crud-table/CREATE_ENTRY_SUCCESS'

export const DELETE_ENTRY = 'crud-table/DELETE_ENTRY'
export const DELETE_ENTRY_SUCCESS = 'crud-table/DELETE_ENTRY_SUCCESS'

export const DELETE_REFERENCE = 'crud-table/DELETE_REFERENCE'

export const GET_NEW_ENTRIES = 'crud-table/GET_NEW_ENTRIES'

export const CHANGE_SORT_STATE = 'crud-table/CHANGE_SORT_STATE'
export const RESET_SORT_STATE = 'crud-table/RESET_SORT_STATE'

export const SET_ENTRY_ERROR = 'crud-table/SET_ENTRY_ERROR'

export function resetSortState (entryType) {
  return dispatch => {
    dispatch({
      type: RESET_SORT_STATE,
      entryType
    })
  }
}

export function changeSortState (entryType, sortOn = 0, sortDir = 'desc') {
  return dispatch => {
    dispatch({
      type: CHANGE_SORT_STATE,
      sortOn,
      sortDir,
      entryType
    })
  }
}

export function getNewEntries () {
  return dispatch => {
    dispatch({ type: GET_NEW_ENTRIES })
  }
}

export function deleteReference (reference) {
  return dispatch => {
    dispatch({
      type: DELETE_REFERENCE,
      reference
    })
  }
}
function getEntriesSuccess (entryType, response, mapFns) {
  let entries = null
  let additionalData = {}

  if (_.isArray(response)) {
    entries = response
  } else {
    if (response.entries) {
      entries = response.entries
    } else if (response.entry) {
      entries = response.entry.map(e => e.resource)
    } else {
      entries = []
    }

    additionalData = _.pick(
      response,
      _.filter(_.keys(response), k => k !== 'entries' && k !== 'entry')
    )
  }

  return {
    type: GET_ENTRIES_SUCCESS,
    entryType,
    entries,
    mapFns,
    additionalData
  }
}

export function getEntries (entryType, urls, mapFns, callBackFn) {
  return dispatch => {
    dispatch({
      type: GET_ENTRIES,
      entryType
    })
    if (_.isFunction(callBackFn)) {
      callBackFn()
    }

    return http.getRequest(urls.get()).then(response => {
      dispatch(getEntriesSuccess(entryType, response, mapFns))
    })
  }
}

export function showNewEntryForm (entryType, entrySet) {
  return {
    type: SHOW_NEW_ENTRY_FORM,
    entryType,
    entrySet
  }
}

export function hideNewEntryForm (entryType, entrySet) {
  return {
    type: HIDE_NEW_ENTRY_FORM,
    entryType,
    entrySet
  }
}

export function deleteEntry (
  entryType,
  urls,
  mapFns,
  entry,
  formData,
  callBackFn
) {
  return dispatch => {
    dispatch(deleteReference(entry))
    dispatch({
      type: DELETE_ENTRY,
      entryData: entry,
      entryType,
      urls,
      mapFns,
      entry,
      formData
    })

    const success = () => {
      dispatch({
        type: DELETE_ENTRY_SUCCESS,
        entryType,
        entry,
        formData
      })
      dispatch(getEntries(entryType, urls, mapFns, callBackFn))
      dispatch(notify(`Successfully Deleted ${_.startCase(entryType)}`), true)
    }

    if (_.isNil(formData)) {
      return http.deleteRequest(urls.delete(entry)).then(success)
    }

    const url = urls.update(entry)
    const body = mapFns.toFhirDelete(entry, formData)

    return http.putRequest(url, body).then(success)
  }
}

export function updateEntry (entryType, entryData, urls, mapFns, callBackFn) {
  const body = mapFns.toFhir(entryData)
  const url = urls.update(entryData)

  return dispatch => {
    dispatch({
      type: UPDATE_ENTRY,
      entryType,
      entryData,
      urls,
      mapFns
    })
    return http
      .putRequest(url, body)
      .then(() => {
        dispatch(
          notify(`Updated ${_.startCase(entryType)} Successfully`),
          true
        )
        dispatch({
          type: UPDATE_ENTRY_SUCCESS,
          entry: entryData,
          entryType
        })
        dispatch(getEntries(entryType, urls, mapFns, callBackFn))
      })
      .catch(() => {
        dispatch(notify(`Error Updating ${_.startCase(entryType)}`), true)
      })
  }
}

export function setListEmpty (
  entryType,
  listUrl,
  clientName,
  value,
  urls,
  mapFns,
  callBackFn
) {
  return dispatch =>
    http
      .putRequest(listUrl, { empty: value }, { clientName })
      .then(() => {
        dispatch(getEntries(entryType, urls, mapFns, callBackFn))
      })
      .catch(() => {
        dispatch(
          notify(`Error marking ${_.startCase(entryType)} List as empty`),
          true
        )
      })
}

export function createEntry (
  entryType,
  entrySet,
  entryData,
  urls,
  mapFns,
  callBackFn,
  index
) {
  const body = mapFns.toFhir(entryData)
  const url = urls.create()

  return dispatch => {
    dispatch({
      type: CREATE_ENTRY,
      entryType,
      entryData,
      urls,
      mapFns
    })

    return http
      .postRequest(url, body)
      .then(response => {
        const newEntry = mapFns.toForm(response)
        dispatch({
          type: CREATE_ENTRY_SUCCESS,
          entry: newEntry,
          entryType
        })
        dispatch({
          type: HIDE_NEW_ENTRY_FORM,
          entryType,
          entrySet
        })
        dispatch(getEntries(entryType, urls, mapFns, callBackFn))
        dispatch(
          notify(`Successfully Created ${_.startCase(entryType)}`),
          true
        )
      })
      .catch(err => {
        if (entryType === 'user') {
          dispatch({
            type: SET_ENTRY_ERROR,
            error: err.response.data?.error ?? 'Something went wrong',
            entryType,
            index
          })
        }
        dispatch(notify(`Error Updating ${_.startCase(entryType)}`), true)
      })
  }
}
